// extracted by mini-css-extract-plugin
export default {"cabecalho":"Cabecalho_cabecalho__HMrxR","menu":"Cabecalho_menu__Wp6mW","logo":"Cabecalho_logo__7bV10"};